/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { Seo } from '@components/systems'
// index 를 거치면 순환 import 로 모듈 평가 시점에 MONOLITH_NAV_HEIGHT 가 undefined 가 된다 — 직접 경로로 가져온다.
import {
	MonolithNav,
	MONOLITH_NAV_HEIGHT,
} from '@components/systems/monolith/MonolithNav'
// 2026-09-10 모바일 드로어도 Monolith 로 교체. 구 드로어는 drawer/HomeDrawer.tsx 에 보관.
import { MonolithDrawer } from '@components/systems/monolith/MonolithDrawer'
import { mono } from '@components/systems/monolith/monolith.tokens'

import { Outlet } from 'react-router-dom'
import { HomeNavMenuType } from '@redux/types'
import { useLocation } from 'react-router-dom'
import config from '@configs'

export const HomeLayout = (): JSX.Element => {
	// hook
	const location = useLocation()

	const menuList: HomeNavMenuType[] = config.homeMenu()

	return (
		<View css={style}>
			{/* 경로별 메타·canonical. 제품 페이지는 각자 JSON-LD 를 얹어 덮어쓴다. */}
			<Seo />

			<MonolithDrawer menuList={menuList} />
			<View className="mainLayoutInnerView">
				<View className="TabContaxtOuterView">
					{/* 2026-09-08 Monolith 네비로 교체. 기존 HomeNav 는 파일로 보관한다. */}
					<MonolithNav menuList={menuList} />

					<View className={'container'}>
						<View className="toobar" />
						<View className="containerInnerView">
							<Outlet />
						</View>
					</View>
				</View>
			</View>
		</View>
	)
}

const style = css({
	display: 'flex',
	position: 'relative',
	padding: 0,
	height: '100%',
	width: '100%',
	background: mono.bg,

	'.mainLayoutInnerView': {
		position: 'relative',
		display: 'flex',
		height: '100%',
		width: '100%',
		minHeight: '100%',

		'.TabContaxtOuterView': {
			position: 'relative',
			width: '100%',
		},

		'.toobar': {
			height: MONOLITH_NAV_HEIGHT,
		},

		'.container': {
			position: 'relative',
			width: '100%',
			height: '100%',
			flexGrow: 1,
			background: mono.bg,

			'.containerInnerView': {
				position: 'relative',
				zIndex: 3,
				width: '100%',
			},
		},
	},
})
